module.exports = __webpack_public_path__ + "img/galicia-on.721a2884.png";